import { dsColorNew } from "@palette"


// Progress bars (executions, batches, real-time searches): thicker and rounded, on the light track of the palette.
const overrideProgressStyles = () => ({
	MuiLinearProgress: {
		styleOverrides: {
			root: {
				height: 8,
				borderRadius: 4,
				backgroundColor: dsColorNew.grayBorder,
			},
			bar: {
				borderRadius: 4,
			},
		}
	}
})

export default overrideProgressStyles
